/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { Store } from '@stores/Store';
import { api } from '@utils/network';
import App from './App';
import { I18n } from './i18n';

const store = new Store();
const i18n = new I18n(api);

ReactDOM.render(<App store={store} i18nInstance={i18n} />, document.getElementById('app'));
